import { optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { IPageServicesRegistrar } from '@wix/thunderbolt-symbols'
import { PageServicesManagerSymbol } from '@wix/thunderbolt-symbols'
import type { IPagesService } from '@wix/viewer-service-pages/definition'
import { PagesDefinition } from '@wix/viewer-service-pages/definition'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import type { PagesServiceEditorHandlers } from './types'

export const PagesServiceSideEffects = withDependencies(
	[optional(PageServicesManagerSymbol)],
	(servicesManagerGetter?: IPageServicesRegistrar): IModelUpdatesHandlersImplementor<PagesServiceEditorHandlers> => {
		return {
			featureName: name,
			handlers: {
				setCurrentPageId: ({ currentPageId }) => {
					const servicesManager = servicesManagerGetter?.get()
					if (servicesManager?.hasService(PagesDefinition)) {
						const service = servicesManager.getService(PagesDefinition) as IPagesService
						service._updateConfig({ currentPageId })
					}
				},
			},
		}
	}
)
